export default (params) => ({
  trigger: {
    name: 'content_blocks.inspiration.hover_highlight',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'hover',
      params: {
        sub_feature: null,
        item_id: null,
      },
    },
  },
});
